/* eslint-disable react/no-unescaped-entities */
/**
 * MaintenancePage — page institutionnelle affichée pendant la maintenance.
 *
 * Design : palette CONFILEX (navy, ivory, or doré), serif italique pour le
 * titre, mention RGPD discrète, lien admin pour les opérateurs.
 */
import { Link } from "react-router-dom";
import ConfilexLogo from "@/components/ConfilexLogo";

export default function MaintenancePage({ message }) {
  return (
    <div
      className="min-h-screen flex items-center justify-center px-6 py-12 relative overflow-hidden"
      style={{ background: "linear-gradient(180deg, #0B3A2A 0%, #14213D 60%, #0F1A30 100%)" }}
      data-testid="maintenance-page"
    >
      {/* Halo subtil doré */}
      <div
        className="absolute -top-40 -right-40 w-[640px] h-[640px] rounded-full pointer-events-none"
        style={{ background: "radial-gradient(closest-side, rgba(196,164,104,0.18), transparent 70%)" }}
        aria-hidden
      />

      <div className="relative max-w-2xl text-center" data-testid="maintenance-card">
        <div className="flex justify-center mb-10">
          <ConfilexLogo size={72} theme="dark" />
        </div>

        <p className="text-[10px] uppercase tracking-[0.32em] text-[#C9A961] mb-5">
          CONFILEX · Maintenance institutionnelle
        </p>

        <h1 className="font-serif italic text-4xl md:text-5xl text-white leading-[1.1] mb-6">
          Le site est temporairement en maintenance.
        </h1>

        <p className="text-base md:text-lg text-white/80 leading-relaxed mb-8 max-w-xl mx-auto">
          {message || "Nous procédons à une intervention technique afin de maintenir le niveau d'exigence et de confidentialité requis par la plateforme. Nous revenons très bientôt."}
        </p>

        <div className="inline-flex items-center gap-3 px-5 py-3 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm">
          <span className="w-2 h-2 rounded-full bg-[#C9A961] animate-pulse" aria-hidden />
          <p className="text-xs uppercase tracking-[0.22em] text-white/70">
            Statut · Service indisponible
          </p>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 text-xs text-white/55 leading-relaxed">
          <p className="mb-3">
            Vos données restent stockées de manière sécurisée et chiffrée.
            Aucune information n'est utilisée pour entraîner un modèle d'IA.
          </p>
          <p>
            Espace administrateur :{" "}
            <Link to="/login" className="text-[#C9A961] hover:text-white underline-offset-4 hover:underline" data-testid="maintenance-admin-login">
              connexion
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
}
